export function Home() {
  return (
    <main style={{ padding: "2rem", fontFamily: "system-ui, sans-serif" }}>
      <h1>Geo Transport Staff Review</h1>
      <p>
        Restricted staff review workspace. Invoice review for a specific order is available at{" "}
        <code>/review/&lt;orderId&gt;</code>. That workflow is implemented in a later phase.
      </p>
    </main>
  );
}
